import * as THREE from "three";

interface LandBoundaryProps {
  geometry: string;
  floor: number;
}
const parsePolygon = (geometryStr: string): [number, number][] => {
  const match = geometryStr.match(/\(\((.*?)\)\)/);
  if (!match) return [];

  return match[1].split(",").map((pair) => {
    const [x, y] = pair.trim().split(" ").map(Number);
    return [x, y];
  });
};
const LandBoundary: React.FC<LandBoundaryProps> = ({ geometry, floor }) => {
  // Create a closed shape from the vertices
  const shape = new THREE.Shape();
  const vertices = parsePolygon(geometry);
  vertices.forEach((vertex, index) => {
    if (index === 0) {
      shape.moveTo(vertex[0], vertex[1]);
    } else {
      shape.lineTo(vertex[0], vertex[1]);
    }
  });
  shape.closePath();

  // Create geometry from the shape
  const boundary = new THREE.ShapeGeometry(shape);

  return (
    <mesh
      position={[0, (floor - 1) * 3, 0]}
      rotation={[-Math.PI / 2, 0, 0]} // Rotate to be horizontal
    >
      <primitive object={boundary} />
      <meshBasicMaterial
        color="#f0f0f0"
        transparent
        opacity={0.2}
        side={THREE.DoubleSide}
      />
    </mesh>
  );
};

export default LandBoundary;
